export default function youtubeClips() {
    return [
        'https://www.youtube.com/embed/8CfT8yN5tgw'
    ];
}
;
